import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
import Index from "./views/Index.vue";
import { $qu } from "./utils/auth.js";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new Router({
  // mode:"history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      children: [
        {
          path: "/",
          name: "index",
          component: () => import("./views/Index.vue"),
        },
      ],
    },
    // 登录
    {
      path: "/login",
      name: "login",
      component: () => import("./views/login/index.vue"),
    },

    // 注册
    {
      path: "/register",
      name:'register',
      component: () => import("./views/login/register.vue"),
    },

    // 忘记密码
    {
      path: "/forgetPwd",
      name: "forgetPwd",
      component: () => import("./views/login/forgetPwd.vue"),
    },

    // 购物车
    {
      path: "/shoppingCart",
      name: "shoppingCart",
      component: () => import("./views/shoppingCart/index.vue"),
    },
    // 整机专区
    {
      path: "/machine",
      name: "machine",
      component: () => import("./views/Machine/index.vue"),
    },
    // 配件专区详情
    {
      path: "/prodetail/:id",
      name: "prodetail",
      component: () => import("./views/prodetail/index.vue"),
    },
    {
      path: "/video",
      name: "video",
      component: () => import("./views/video/index.vue"),
    },
    {
      path: "/help",
      name: "help",
      component: () => import("./views/help/index.vue"),
    },
    // 订单确认
    {
      path: "/orderConfirm/:id/:num?/:guigeid?",
      name: "orderConfirm",
      component: () => import("./views/orderConfirm/index.vue"),
    },

    // 订单详情
    {
      path: "/orderPayment/:id/:ids",
      name: "orderPayment",
      component: () => import("./views/orderPayment/index.vue"),
    },
    // 企业认证
    {
      path: "/companyAuth",
      component: () => import("./views/companyAuth/index.vue"),
    },
    {
      path: "/user",
      name: "Layout",
      component: () => import("./views/user/Layout.vue"),
      // redirect: "/user/userInfo", // 默认进入“个人信息”
      // 嵌套路由
      children: [
        {
          path: "userInfo", // 个人信息
          name: "userInfo",
          component: () => import("./views/user/userInfo.vue"),
        },
        {
          path: "order", // 订单
          name: "order",
          component: () => import("./views/user/order.vue"),
        },

        {
          path: "orderDetails/:id", // 订单详情
          name: "orderDetails",
          component: () => import("./views/user/orderDetails.vue"),
        },

        {
          path: "orderWeiBao", // 维保
          component: () => import("./views/user/orderWeiBao.vue"),
        },

        {
          path: "address", // 收货地址
          name: "address",
          component: () => import("./views/user/address.vue"),
        },
        {
          path: "coupon", // 优惠卷
          component: () => import("./views/user/coupon.vue"),
        },

        {
          path: "collectCoupon", // 领取优惠卷
          component: () => import("./views/user/collectCoupon.vue"),
        },

        {
          path: "invoice", // 我的发票
          component: () => import("./views/user/invoice.vue"),
        },
      ],
    },
    // {
    // 	path: '/denglu',
    // 	name: 'denglu',
    // 	component: () => import('./views/App/denglu.vue')
    // },

    // {
    // 	path: '/windex',
    // 	name: 'windex',
    // 	component: () => import('./views/Appweixing/windex.vue')
    // },
    // {
    // 	path: '/xinzeng_yingyong',
    // 	name: 'xinzeng_yingyong',
    // 	component: () => import('./views/Appweixing/xinzeng_yingyong.vue'),
    // 	meta: { title: '创建小程序', noCache: true, activeMenu: './views/Appweixing/windex.vue'},
    // },

    // {
    // 	path: '/zhuce',
    // 	name: 'zhuce',
    // 	component: () => import('./views/App/zhuce.vue')
    // },
    // {
    // 	path: '/zhaohuimima',
    // 	name: 'zhaohuimima',
    // 	component: () => import('./views/App/zhaohuimima.vue')
    // },
    // {
    // 	path: '/dianpuzhuanxiu',
    // 	name: 'dianpuzhuanxiu',
    // 	component: () => import('./views/App/dianpuzhuanxiu.vue')
    // },
  ],
});

// router.beforeEach(async (to, from, next) => {

// 	let kouling = $qu('yonghu')['kouling'];

// 	if(to.name == 'denglu' || to.name == 'zhuce' || to.name=='zhaohuimima' ){
// 		next();
// 		return false;
// 	}

// 	if (to.name !== 'denglu' && !kouling) {
// 		next({
// 			name: 'denglu'
// 		})
// 	} else {
// 		await store.dispatch('huoququanxian')
// 		await store.dispatch('huoquzongquanxian')
// 		if (store.state.zongquanxian.lie) {
// 			// 判断是否需要管理权限
// 			let guanli = store.state.zongquanxian.lie.filter((e) => {
// 				return e.url == to.name ? true : false
// 			});
// 			if (guanli.length > 0) {
// 				// 判断是否拥有管理权限
// 				let ye = store.state.quanxian.lie.filter((e) => {
// 					return e.url == to.name ? true : false
// 				});
// 				if (ye.length > 0) {
// 					next();
// 				} else {
// 					let ketiaoyemian = store.state.quanxian.lie.filter((e) => {
// 						return e.url ? true : false
// 					});
// 					next({
// 						name: ketiaoyemian[0].url
// 					});
// 				}
// 			} else {
// 				next();
// 			}
// 		} else {
// 			next();
// 		}
// 	}
// })

export default router;